export default __webpack_public_path__ + "static/media/900.7e63df6d.png";